
export default {
  props: {
    to: String,
    text: { default: "اضافة", type: String },
    color: { default: "primary", type: String },
  },
};
